module.exports = __webpack_public_path__ + "school/img/train_signup_bg.49e425a9.jpg";